module.exports = __webpack_public_path__ + "img/australia-endocrine-nutritional-metabolic-diseases-male.3f5071a7.png";